import React from 'react';

const CookieBanner: React.FC<{
  closeCallback: () => void;
  hiddenClass: string;
  data?: CookieBanner;
}> = ({ closeCallback, hiddenClass, data }) => {
  const privacyHref = 'https://bunny.net/privacy';

  return (
    <div className={`bn-cookies-wr ${hiddenClass}`}>
      <img
        src={data?.src || '/bn-cookies/bn-cookies.svg'}
        alt={data?.alt || 'Cookie message'}
        style={{
          ...(data?.offset?.horizontal !== 0 || data?.offset?.vertical !== 0
            ? {
                translate: `${data?.offset?.horizontal ?? 0}rem ${data?.offset?.vertical ?? 0}rem`,
              }
            : {}),
          scale:
            data?.scale?.x === 1 && data?.scale?.y === 1
              ? undefined
              : `${data?.scale?.x ?? 1} ${data?.scale?.y ?? 1}`,
          width: data?.width ? data.width + 'rem' : '',
          height: data?.height ? data.height + 'rem' : '',
        }}
      />
      <div className='message'>
        We use cookies to improve your user experience.{' '}
        <a href={privacyHref}>Learn more</a>
      </div>
      <div
        className='close'
        onClick={closeCallback}
      >
        x
      </div>
    </div>
  );
};

export const COOKIE_COOKIES = 'bn_cookies';

export default CookieBanner;
